import { IPersistenceContainer } from '../../abstracts/persistence.container';

const /** @type {?} */ INFO_KEY = '__INFO';
/**
 * An internal object used to track items saved by a storage object within the persistence
 * framework.
 * 
 * @export
 * \@class ContainerInfo
 * 
 * @author Scott O'Bryan
 * \@since 1.0
 */
export class ContainerInfo {
/**
 * @param {?} _namespace
 * @param {?} _container
 */
constructor(private _namespace: string,
private _container: IPersistenceContainer) {
        let infoObj = _container.get(this._namespace);

        // If we have an existing object, check its type
        if (infoObj) {
            if (typeof infoObj !== 'object' || !infoObj[INFO_KEY]) {
                throw new Error('Potential attribute conflict detected');
            }    
        }
    }
/**
 * Adds a key to this info object.
 * 
 * @param {?} key
 * @return {?}
 */
public addAttribute(key: string) {
        let /** @type {?} */ item = this._getInfo();
        item[key] = true;
        this._setInfo(item);
    }
/**
 * Removes a key from this info object.
 * 
 * @param {?} key
 * @return {?}
 */
public removeAttribute(key: string) {
        let /** @type {?} */ info = this._getInfo();
        delete info[key];
        this._setInfo(info);
    }
/**
 * Returns a list of keys that have been added to this
 * info object.
 * 
 * @return {?}
 */
public getAttributes(): string[] {        
        return Object.keys(this._getInfo())
            .filter((key) => key !== INFO_KEY);
    }
/**
 * Checks to see if the value stored in the _namespace
 * is an info object or if it is empty.  If it is NOT
 * an info object, then false is returned.
 * 
 * @return {?}
 */
public available(): boolean {
        let /** @type {?} */ infoObj = this._container.get(this._namespace);
        return !infoObj || (typeof infoObj === 'object' &&  infoObj[INFO_KEY]);
    }
/**
 * @return {?}
 */
private _getInfo(): any {
        let /** @type {?} */ obj = this._container.get(this._namespace);

        if (!obj) {
            obj = {};
            obj[INFO_KEY] = true;
        }

        return obj;
    }
/**
 * @param {?} info
 * @return {?}
 */
private _setInfo(info: any) {
        // this is 1 because the info identifier will be there.
        if (Object.keys(info).length <= 1) {
            this._container.remove(this._namespace);
        } else {
            this._container.set(this._namespace, info);
        }
    }
}

function ContainerInfo_tsickle_Closure_declarations() {
/** @type {?} */
ContainerInfo.prototype._namespace;
/** @type {?} */
ContainerInfo.prototype._container;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
